import Experience from "@folio-2026/experience"
import { EVENTS } from "@folio-2026/shared"
import { ButtonEvent, TextScene } from "@folio-2026/text"

import { useLoadingStore } from "./store"

export default class EnterCTA {
  experience: Experience
  textScene: TextScene
  id: string = "enter-cta"

  constructor({ textScene }: { textScene: TextScene }) {
    this.experience = Experience.getInstance()

    this.textScene = textScene

    this.setEventListeners()
  }

  setEventListeners() {
    this.experience.on(
      EVENTS.Loader.EnterCTA.Click,
      this.clickHandler.bind(this),
    )

    this.experience.on(
      EVENTS.Loader.EnterCTA.Hover,
      this.hoverHandler.bind(this),
    )
    this.experience.on(EVENTS.Loader.EnterCTA.Out, this.outHandler.bind(this))
  }

  hoverHandler(e: unknown) {
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }

    useLoadingStore.getState().setHasEnterHover(true)
  }

  outHandler(e: unknown) {
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }

    useLoadingStore.getState().setHasEnterHover(false)
  }

  clickHandler() {
    useLoadingStore.getState().setHasClicked(true)
    this.experience.trigger(EVENTS.Loader.Entered)

    if (window.location.pathname === "/") {
      this.experience.lenis?.start()
    }
  }
}
